import classnames from 'classnames/bind'
import React from 'react'

import AlternateTextImage, {
  AlternateTextImageProps,
} from '~/components/EditoAlternateTextImage/AlternateTextImage'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface EditoAlternateTextImageProps {
  className?: string
  items?: AlternateTextImageProps[]
}

function EditoAlternateTextImage({
  className,
  items,
}: EditoAlternateTextImageProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <div className={cx(css.EditoAlternateTextImage, gridStyle, className)}>
      <div className={css.content}>
        {items?.map((item, index) => {
          const isOdd = index % 2 !== 0
          return (
            <AlternateTextImage
              className={css.item}
              inversed={isOdd}
              key={`edito_alternate_image_${index}`}
              {...item}
            />
          )
        })}
      </div>
    </div>
  )
}

EditoAlternateTextImage.defaultProps = {}

export default EditoAlternateTextImage
